const MODULE = "Queue Management"
const QUEUE_MODULE_ID = 7

const MODULE_DESCRIPTION =
  "Queue management enables students to enter a queue when maximum pass limit for a location has been reached or exceeded."

const PATHS = Object.freeze({
  ROOT: "/queue/settings",
  SETTINGS: "/queue/settings/manage"
})

const QUEUE_ADMIN_ROLES = ["superadmin", "admin"]

const ROUTE_DEPENDENCY = Object.freeze({
  SETTINGS: "routerDependencies/hasQueueSettingsRouteAccess"
})

const FORM_VALIDATIONS = Object.freeze({
  CLEAR_TIME_REQUIRED: "This field is required",
  LABEL_TEXT_REQUIRED: "This field is required",
  AT_LEAST_ONE_DAY: "At least one day must be selected"
})

export default {
  MODULE,
  MODULE_DESCRIPTION,
  QUEUE_MODULE_ID,
  PATHS,
  QUEUE_ADMIN_ROLES,
  ROUTE_DEPENDENCY,
  FORM_VALIDATIONS
}
